import enMessages from '@/messages/en.json';

export const messages = enMessages;
